import { ReactComponent as FrameIcon } from 'assets/svg/frame.svg';
import useAISearchMutation from 'hooks/useAISearchMutation';
import { SubmitHandler, useForm } from 'react-hook-form';
import { ClipLoader } from 'react-spinners';
import { useSearchAiPluginStore } from 'store/searchAiPluginStore';
interface Props {
    showImage?: boolean;
    isInputDisabled?: boolean;
}

interface FormData {
    prompt: string;
}

const SearchSection: React.FC<Props> = ({ showImage = true, isInputDisabled = false }) => {
    const { customization } = useSearchAiPluginStore();

    const { register, handleSubmit } = useForm<FormData>({
        defaultValues: {
            prompt: '',
        },
    });

    const { mutate: aiSearch, isPending } = useAISearchMutation({});

    const onSubmit: SubmitHandler<FormData> = (data) => aiSearch(data.prompt);

    return (
        <form className=" mx-autopx-4 p-10" onSubmit={handleSubmit(onSubmit)}>
            <div className={`mx-auto flex gap-2 w-[1000px] mt-4 ${customization.buttonSize === 'big' ? 'border rounded-lg bg-white p-6' : ''} `}>
                <div className="relative flex-1 items-center">
                    <input
                        type="text"
                        placeholder={customization.searchButtonText}
                        className="w-full h-14 p-3 border-2  rounded-lg pl-10  bg-white shadow-sm"
                        style={{ borderColor: customization.searchButtonColor }}
                        disabled={isInputDisabled}
                        {...register('prompt')}
                    />
                    <FrameIcon className="absolute left-2 top-3.5 " style={{ color: customization.searchButtonColor }} />
                    {customization.buttonSize === 'small' &&
                        (isPending ? (
                            <ClipLoader color={customization.searchButtonColor} loading className="absolute right-4 top-2" />
                        ) : (
                            <button
                                type="submit"
                                className={`px-6 py-2
                        text-white font-medium rounded-lg
                         shadow-sm
                         absolute right-4 top-2 cursor-pointer sm:block
                         flex items-center justify-center`}
                                style={{ backgroundColor: customization.searchButtonColor }}
                                disabled={isInputDisabled}
                            >
                                Search
                            </button>
                        ))}
                    {(customization.buttonSize === 'medium' || customization.buttonSize === 'big') && (
                        <>
                            {isPending ? (
                                <div className="flex items-center justify-center mt-3">
                                    <ClipLoader color={customization.searchButtonColor} loading />
                                </div>
                            ) : (
                                <button
                                    type="submit"
                                    className={`px-6 py-3 text-white font-medium rounded-lg
                shadow-sm w-full mt-3 sm:block
                flex items-center justify-center`}
                                    style={{ backgroundColor: customization.searchButtonColor }}
                                    disabled={isInputDisabled}
                                >
                                    Search
                                </button>
                            )}
                            {showImage && (
                                <p className="mt-2 text-sm text-gray-400 flex justify-end gap-1">
                                    POWERED BY
                                    <span className="font-bold text-black"> hello:data</span>
                                    <img src="/image/Logo_65_80.png" className="w-5 h-5 bg-contain" />
                                </p>
                            )}
                        </>
                    )}
                    {showImage && customization.buttonSize === 'small' && (
                        <p className=" mt-2 text-sm text-gray-400  absolute right-4 top-[54px]">
                            POWERED BY
                            <span className="font-bold text-black">
                                {' '}
                                hello:data
                                <img src="/image/Logo_65_80.png" className="w-5 h-5 bg-contain absolute right-[-20px] top-[-1px]" />
                            </span>
                        </p>
                    )}
                </div>
            </div>
        </form>
    );
};

export default SearchSection;
